import React from 'react';
import { formatTime } from '../../utils/helper';

const QuestionInfo = ({ form, timer }) => {
    const posName = form?.positionTitle ?? 'Position Name';
    const candidateName = form?.candidateName ?? 'Candidate Name';

    return (
        <div className="question-timer-div-main d-flex gap-10 org-position-container">
            <div className="question-title org-position" title={candidateName}>
                Candidate Name
                <br />
                {candidateName}
            </div>
            <div className="question-title org-position" title={posName}>
                Position Name
                <br />
                {posName}
            </div>
            <div className="question-titlev2 org-position">
                Time Left
                <br />
                {formatTime(timer) ?? '00:00'}
            </div>
        </div>
    );
};

export default QuestionInfo;
